Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-productcompare-widget');
    $wrapper.attr('data-template', '2');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var model = null, loaded = false, openWidget = false;

    var lazyLoadPrices = $wrapper.data('lazyload-prices');
    if (typeof lazyLoadPrices === 'string') {
        lazyLoadPrices = lazyLoadPrices.trim().toLowerCase() === 'true';
    }

    wrapper.open = function () {
        $('.js-widget-trigger', $wrapper).addClass('x-open');
        $('.js-widget-container', $wrapper).addClass('x-expanded');

        openWidget = false;
    };

    wrapper.close = function () {
        $('.js-widget-trigger', $wrapper).removeClass('x-open');
        $('.js-widget-container', $wrapper).removeClass('x-expanded');
    };

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.extendModel = function () {
        model = { ...model, ...{ ClientEnhancedModel: window.LhApp.ClientEnhancedModel } }; // model to be expanded from page html (window.LhApp = window.LhApp || {}; window.LhApp.ClientEnhancedModel = window.LhApp.ClientEnhancedModel || {};
    };

    wrapper.minimalUpdate = function () {
        if (model.ProductsCount > 0) {
            $('.js-widget-trigger', $wrapper).addClass('has-items');
            $('.number', $wrapper).text(model.ProductsCount);
        } else if (model.ProductsCount == 0) {
            $('.js-widget-trigger', $wrapper).removeClass('has-items');
            $('.number', $wrapper).text('');
        }

        if (loaded && !$('.js-widget-trigger', $wrapper).hasClass('x-open')) {
            loaded = false;
            $('.js-widget-container', $wrapper).empty();
        }
    };

    wrapper.update = function () {
        wrapper.loading(true);

        if (model.ProductsCount >= 5) {
            model.MaxProductsExceeded = true;
        } else {
            model.MaxProductsExceeded = false;
        }

        var html = Vendd.Handlebars.parse("productCompareWidget_B", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function (html) {
        $('.js-widget-container', $wrapper).html(html);

        //init fancybox
        $(".btn-productcompare.pop-up", $wrapper).fancybox({
            smallBtn: true,
            toolbar: false,
            baseClass: "compare-pop-up",
            afterShow: function () {
                $('html').addClass('hide-sticky-btns');
            }
        });

        if (openWidget) wrapper.open();
    };

    $wrapper.on('click', '.js-remove', function (e) {
        e.preventDefault();

        var $this = $(this);
        var $item = $this.closest('.productcompare-item');
        var id = $item.data('identifier');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.Remove(id));
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
    });

    $wrapper.on('click', '.js-remove-all', function (e) {
        e.preventDefault();

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.Clear());
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
    });

    //On click Compare Button
    $wrapper.on('click', '.js-widget-trigger', function (e) {
        e.preventDefault();

        if (model === null) return;

        if ($(this).hasClass('x-open')) {
            $('.header-overlay').removeClass('visible');
            $('.header-region').removeClass('clean-zindex');
            $('html, body').removeClass('no-scroll');
            $('.js-widget-container', $wrapper).addClass('animation');
            wrapper.close();
        } else {
            if (!loaded) {
                wrapper.extendModel();
                wrapper.update();
                loaded = true;
            }
            $('html, body').addClass('no-scroll');
            if ($('.header-region').hasClass('sticky')) {
                $('.header-spacer').height(0);
                $('.header-region').removeClass('sticky');
            }
            $('.header-region').addClass('clean-zindex');
            $('.header-overlay').addClass('visible');
            $('.js-widget-container', $wrapper).addClass('animation');
            wrapper.loading(false);
            wrapper.open();
        }

    });

    //On click Close Button inside Compare Widget
    $wrapper.on('click', '.close-button', function (e) {
        e.preventDefault();

        $('.header-overlay').removeClass('visible');
        $('.header-region').removeClass('clean-zindex');
        $('html, body').removeClass('no-scroll');
        $('.js-widget-container', $wrapper).addClass('animation');
        wrapper.close();
    });

    //On click outside Compare Widget
    $('.header-overlay').on('click', function (e) {
        e.preventDefault();

        $('.header-overlay').removeClass('visible');
        $('.header-region').removeClass('clean-zindex');
        $('html, body').removeClass('no-scroll');
        $('.js-widget-container', $wrapper).addClass('animation');
        wrapper.close();
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.ProductCompareAdded, wrapper, function (envelope) {
        var validation = envelope.message.data.code;
        var erroMessage = JSON.parse(envelope.message.data.data).Messages[0];
        if (validation == 'ValidationError') {
            toastr.warning(erroMessage, "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        } else {
            toastr.success(LhApp.Function.getText("Common:ProductAddedToCompare"), "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        }
       
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.ProductCompareRemoved, wrapper, function (envelope) {
        toastr.success(LhApp.Function.getText("Common:ProductRemovedFromCompare"), "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.Changed, wrapper, function (envelope) {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetWidgetModel());
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetWidgetModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.model;
        wrapper.extendModel();
        wrapper.minimalUpdate();
       
        if (loaded)
            wrapper.update();

        if ($wrapper.hasClass('x-loading') && !$('.js-widget-trigger', $wrapper).hasClass('x-open')) {
            $('.js-widget-trigger', $wrapper).trigger("click");
        } 
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, wrapper, function (envelope) {
        if (envelope.message.data.widgetName !== Vendd.Widget.ProductCompareWidget) {
            wrapper.close();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.OpenWidget, wrapper, function (envelope) {
        if (envelope.message.data.widgetName === Vendd.Widget.ProductCompareWidget) {
            if (envelope.message.data.immediate === true)
                wrapper.open();
            else
                openWidget = true; // the next refresh will open it
        }
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, wrapper, function (envelope) {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetWidgetModel());
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutSuccess, wrapper, function (envelope) {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetWidgetModel());
    });

    //keep last in component's code
    (function () {
        var defaultCallExecuted;
        function defaultCall() {
            if (Vendd.User.SessionState && !defaultCallExecuted) {
                defaultCallExecuted = true;
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetWidgetModel());
            }
        }
        defaultCall();
        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, wrapper, function (envelope) {
            defaultCall();
        });
    })();
});

